module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/carType-8980e6998d483138a81711c2317e1834.png";